export default class Invoice {
  constructor(initializer) {
    this.billing_document_number = initializer.billing_document_number;
    this.document_number_finance = initializer.document_number_finance;
    this.line_item_in_the_relevant_invoice =
      initializer.line_item_in_the_relevant_invoice;
    this.finance_document_type = initializer.finance_document_type;
    this.clearing_document_number_finance =
      initializer.clearing_document_number_finance;
    this.reference_number = initializer.reference_number;
    this.fiscal_year_of_the_relevant_invoice =
      initializer.fiscal_year_of_the_relevant_invoice;
    this.finance_document_only = initializer.finance_document_only;
    this.item_is_a_payment = initializer.item_is_a_payment;
    this.read_only_flag = initializer.read_only_flag;
    this.soldto_number = initializer.soldto_number;
    this.payer_number = initializer.payer_number;
    this.posting_date = initializer.posting_date;
    this.document_date = initializer.document_date;
    this.due_date = initializer.due_date;
    this.clearing_date = initializer.clearing_date;
    this.days_in_arrears = initializer.days_in_arrears;
    this.currency_key = initializer.currency_key;
    this.total_amount = initializer.total_amount;
    this.paid_amount = initializer.paid_amount;
    this.open_amount = initializer.open_amount;
    this.pdf_document_available = initializer.pdf_document_available;
    this.zzcustom = initializer.zzcustom;
  }
}
